module.exports = __webpack_public_path__ + "img/vilella.74143cae.png";